var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStoreWithBackground = function SvgStoreWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 71,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#store_with_background_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#B3D8D3",
    d: "M54.07 15.199H10.261A2.66 2.66 0 0 0 7.6 17.86v43.212a2.66 2.66 0 0 0 2.662 2.663H54.07a2.663 2.663 0 0 0 2.662-2.662V17.86a2.663 2.663 0 0 0-2.663-2.662Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M16.537 27.29a1 1 0 0 1 .999 1v25.457H59.23V28.29a.998.998 0 1 1 1.997 0v26.457a1 1 0 0 1-.998.998H16.537a1 1 0 0 1-.998-.998V28.289c0-.551.447-.998.998-.998Zm1.457-20.094a1 1 0 0 1 .886-.54h39.006c.373 0 .715.208.886.54l5.8 11.2a.998.998 0 1 1-1.773.918l-5.52-10.66H19.488l-5.521 10.66a.998.998 0 0 1-1.773-.918z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M51.034 17.857c.552 0 .999.447.999.998v3.692a5.33 5.33 0 1 0 10.654-.027v-3.665a.998.998 0 1 1 1.997 0v3.653a7.33 7.33 0 0 1-7.324 7.506 7.326 7.326 0 0 1-7.324-7.506v-3.653c0-.551.447-.998.998-.998m-37.954 0c.552 0 .999.447.999.998v3.692a5.33 5.33 0 1 0 10.654-.027v-3.665a.999.999 0 0 1 1.997 0v3.653a7.327 7.327 0 1 1-14.648 0v-3.653c0-.551.447-.998.998-.998",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M25.732 17.857c.551 0 .998.447.998.998v3.692a5.33 5.33 0 1 0 10.655-.027v-3.665a.998.998 0 1 1 1.996 0v3.653a7.327 7.327 0 1 1-14.648 0v-3.653c0-.551.447-.998.999-.998",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M38.383 17.857c.551 0 .998.447.998.998v3.692a5.33 5.33 0 1 0 10.655-.027v-3.665a.998.998 0 1 1 1.997 0v3.653a7.325 7.325 0 0 1-12.573 5.291 7.33 7.33 0 0 1-2.075-5.291v-3.653c0-.551.447-.998.998-.998",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M38.383 6.656c.551 0 .998.447.998.999v11.2a.998.998 0 0 1-1.996 0v-11.2c0-.552.447-.999.998-.999m9.936.024a1 1 0 0 1 1.191.758l2.499 11.2a.998.998 0 1 1-1.95.434l-2.497-11.2a1 1 0 0 1 .757-1.192m-19.872 0c.539.12.878.654.758 1.192l-2.499 11.2a.998.998 0 0 1-1.949-.434l2.498-11.2a1 1 0 0 1 1.192-.758m-6.341 28.519c0-.552.447-.999.999-.999h11.222c.552 0 .999.447.999.998v19.543a1 1 0 0 1-.999.999H23.105a1 1 0 0 1-.999-.999V35.2Zm1.997.998v17.546h9.226V36.197zm14.963-.998c0-.552.447-.999.999-.999h13.698c.552 0 .999.447.999.998v10.46a1 1 0 0 1-.999.998H40.065a1 1 0 0 1-.999-.998v-10.46Zm1.997.998v8.462h11.702v-8.462z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#017C6B",
    fillRule: "evenodd",
    d: "M12.082 18.855c0-.551.447-.998.998-.998h50.606a.998.998 0 0 1 0 1.997H13.08a1 1 0 0 1-.998-.999",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "store_with_background_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h71v71H.5z"
  })))));
};
export default SvgStoreWithBackground;